import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { useCopyClick } from 'modules/common/hooks/useCopyClick';
import { useGlobalTranslation } from 'modules/i18n/hooks/useGlobalTranslation';

import { useStyles } from './useStyles';

interface ICopyProps {
  className?: string;
  text: string;
  children?: string | ReactElement;
}

export function Copy({ className, text, children }: ICopyProps): ReactElement {
  const { t, keys } = useGlobalTranslation();
  const { classes, cx } = useStyles();

  const { onCopyClick, isCopied } = useCopyClick();

  return (
    <Typography
      className={cx(classes.root, className)}
      component="button"
      type="button"
      variant="body1"
      onClick={() => onCopyClick(text)}
    >
      {isCopied ? t(keys.common.copied) : children || t(keys.common.copy)}
    </Typography>
  );
}
